export default __webpack_public_path__ + "static/media/current-work-glyph-16px.e3403ea3.svg";